import { useEffect, useState } from 'react';

import { StackableModal } from '../components/nextgen';
import { TemplateField } from '../components/Attributes/Attributes_old';
import BetaAttributes from '../components/Attributes';

import Button from '../components/Button';

import useRequired from '../hooks/useRequired';
import useModal from '../hooks/useModal';
import useAsync from '../hooks/useAsync';

import { addCategory } from '../api/categories';
import { getModules } from '../api/modules';

const MODAL_NAME = 'addCategoryModal';

const QuickAddCategory = () => {
	const [form, setForm] = useState({});

	const { open: options, setClose } = useModal(MODAL_NAME);

	const { execute: onAddCategory, status: isAddingCategory } = useAsync(
		addCategory,
		{ immediate: false },
	);

	useEffect(() => {
		if (options) {
			setForm({
				moduleId: options?.moduleId || null,
			});

			// If moduleKey is provided, fetch the module to get moduleId
			if (options?.moduleKey && !options?.moduleId) {
				getModules({ key: options.moduleKey })
					.then((response) => {
						const module = response?.rows?.find(
							(m) => m.key === options.moduleKey,
						);
						if (module) {
							setForm((prev) => ({ ...prev, moduleId: module.id }));
						}
					})
					.catch((error) => {
						console.error('Failed to fetch module by key:', error);
					});
			}
		} else {
			setForm({});
		}
	}, [options]);

	return (
		<StackableModal
			title="Create Category"
			open={!!options}
			onClose={() => setClose()}
			size="md"
		>
			<div className="grid grid-cols-2 gap-y-4 gap-x-4 text-left pt-4">
				{options?.moduleId || options?.moduleKey ? null : (
					<BetaAttributes
						field={{ label: 'Module', type: 'module', required: true }}
						form={form}
						onChange={(index, value) =>
							setForm({ ...form, ['moduleId']: value })
						}
						key={'module'}
					/>
				)}

				<TemplateField
					name="Name"
					dataIndex="name"
					onChange={(index, category) =>
						setForm({ ...form, [index]: category })
					}
				/>
			</div>
			<div className="flex justify-end mt-6 px-4 pb-4">
				<Button
					onClick={() => {
						onAddCategory(
							{
								name: form?.name,
								moduleId: form?.moduleId?.value || form?.moduleId,
								organizationId: options?.organizationId,
							},
							(response) => {
								if (typeof options?.onSubmit === 'function') {
									options?.onSubmit({
										label: response.name,
										value: response.id,
									});
									setForm({});
								}
								setClose();
							},
						);
					}}
					disabled={!useRequired(form, ['name', 'moduleId'])}
				>
					{isAddingCategory === 'pending' ? 'Adding Category' : 'Add Category'}
				</Button>
			</div>
		</StackableModal>
	);
};

export default QuickAddCategory;
